import {setFetchingForView, setMetaProp, setView, setCurrent} from '../../../helpers'

export default {
  setFetchingForView,
  setCurrent,
  setMetaProp,
  setView
}


// WEBPACK FOOTER //
// ./src/store/modules/bioreq/mutations.js